import React, { memo } from 'react'

import { EntityToolbar } from '@tranzact/platform_react-components'

const Toolbar = props => <EntityToolbar options={[]} {...props} />

export default memo(Toolbar)
